// Supabase Auth (GoTrue + bcrypt) rejects passwords longer than 72 UTF-8 bytes,
// so the browser must apply the same limit instead of the legacy 128-character rule.
export const PASSWORD_MIN_CHARS = 6;
export const PASSWORD_MAX_BYTES = 72;
export const PASSWORD_MAX_CHARS = 72;
export const PASSWORD_HINT =
  '密码需为 6–72 个字符，建议使用较长短语；中文等字符按 UTF-8 计算，最多约 24 个汉字。';

export function passwordProblem(value: string): string | null {
  if (Array.from(value).length < PASSWORD_MIN_CHARS)
    return `密码至少需要 ${PASSWORD_MIN_CHARS} 个字符。`;
  if (new TextEncoder().encode(value).length > PASSWORD_MAX_BYTES)
    return '密码过长：最多 72 字节，约 24 个汉字。';
  return null;
}
